import { configure } from '@mos-utils/drafts';

export const draft = configure({
  apiBase: '/api/exam-appeal/v1/drafts',
  serviceID: 'appeal',
  xCallerId: 'service::appeal',
});
